/**
 * abilityVfxAdcMeshes — Shape dispatch for SPY-410 ADC wave (OCP).
 */
import {
  buildMysticShot,
  buildEssenceFlux,
  buildArcaneShift,
  buildTrueshotBarrage
} from './abilityVfxEzreal.js';
import {
  buildPiltoverPeacemaker,
  buildYordleSnapTrap,
  buildCaliberNet,
  buildAceInTheHole
} from './abilityVfxCaitlyn.js';

const ADC_SHAPE_BUILDERS = {
  mystic_shot: buildMysticShot,
  essence_flux: buildEssenceFlux,
  arcane_shift: buildArcaneShift,
  trueshot_barrage: buildTrueshotBarrage,
  piltover_peacemaker: buildPiltoverPeacemaker,
  yordle_snap_trap: buildYordleSnapTrap,
  caliber_net: buildCaliberNet,
  ace_in_the_hole: buildAceInTheHole
};

/** @returns {object|null} */
export function buildAdcAbilityMesh(THREE, spec) {
  const build = ADC_SHAPE_BUILDERS[spec?.shape];
  return build ? build(THREE, spec) : null;
}
